import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
} from "@material-ui/core";
import {
  PaymentApi,
  StudentMonthlyPaymentSituationDto,
} from "../../api-clients/api";
import Loading from "../Shared/Loading";
import NoResult from "../Shared/NoResult";
import { Text } from "@fluentui/react";
import { green, red } from "@material-ui/core/colors";
import { getApiUrl } from "../../api-clients";
import { useTranslation } from "react-i18next";

interface IProps {
  studentPathId: string;
}
export default function PaymentsMonthlySituation({ studentPathId }: IProps) {
  const { t } = useTranslation();
  const [paymentApi] = useState<PaymentApi>(new PaymentApi(getApiUrl()));
  const [results, setResults] = useState<
    StudentMonthlyPaymentSituationDto[] | null
  >(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(true);
    paymentApi
      .monthPaymentsByStudentPathId(studentPathId)
      .then((res) => {
        setResults(res);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, [paymentApi, studentPathId]);

  return (
    <>
      <Card>
        <CardHeader title={t("students.annualSituation")} />

        <CardContent>
          {!isLoading ? (
            results != null && results.length > 0 ? (
              <Grid container spacing={1}>
                {results.map((r) => (
                  <Grid item key={`${r.month}/${r.year}`}>
                    <Grid container alignItems="center">
                      <div>
                        <Text variant="mediumPlus" block>{`${
                          (r.month ?? "").toString().length > 1
                            ? r.month
                            : "0" + r.month
                        }/${r.year}`}</Text>
                        <Text
                          style={{
                            color: (r.isPaid
                              ? green[600]
                              : red[600]
                            ).toString(),
                          }}
                          variant="xSmall"
                          block
                        >
                          {r.isPaid
                            ? t("students.paid")
                            : t("students.notPaid")}
                        </Text>
                      </div>
                    </Grid>
                    <Divider orientation="vertical" flexItem />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <NoResult />
            )
          ) : (
            <Loading />
          )}
        </CardContent>
      </Card>
    </>
  );
}
